<div class="d-flex align-self-baseline mt-3 top-level">
  <div class="card fitting-cards flex-fill">
    <div class="card-header text-center bg-dark bg-gradient text-white text-nowrap"><b>Fitting Product
        Specifications</b></div>

    <div class="card-body">
      <ng-template #loader>
        <app-loader *ngIf="showLoader"></app-loader>
      </ng-template>

      <ng-container *ngIf="!showLoader else loader">
        <div class="d-flex flex-column" *ngIf="!!product">
          <!-- <button *ngIf="!!isAdmin" class="ms-auto btn btn-outline-secondary btn-sm edit-button" (click)="editRecord(product)"><i
               class="fa fa-lock"></i> Edit Record</button> -->
          <div class="d-flex flex-wrap">
            <ng-container *ngIf="!!hasDrawing">
              <b class="w-25 text-nowrap">Product/Part&nbsp;#:</b>
              <a class="cursor-pointer text-tdw ms-auto"
                 (click)="getFittingDrawing.emit(product.partNumber + '-CIP')"><b>{{activePartNumber}}</b></a>
            </ng-container>
            <ng-container *ngIf="!hasDrawing"><b class="w-25 text-nowrap">Product/Part&nbsp;#:</b><span
                    class="ms-auto text-tdw">{{activePartNumber}}</span></ng-container>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Name:</b><span class="ms-auto">{{product.productName}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Description:</b><span class="ms-auto">{{product.description}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Fitting Type:</b><span class="ms-auto">{{product.fittingTypeText}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Region:</b><span class="ms-auto">{{product.hemisphereText}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Limit 1.25":</b><small class="ms-auto text-uppercase">{{product.limit125 ? 'Yes'
              :
              'No'}}</small>
          </div>
          <div class="d-flex flex-wrap" *ngIf="!!product.leadTime">
            <b class="w-25 text-nowrap">Lead Time:</b><small
                   class="ms-auto text-uppercase">{{product.leadTime}}&nbsp;days</small>
          </div>
          <div class="d-flex flex-wrap" *ngIf="!!product.surge">
            <b class="w-25">Surge:</b><small class="ms-auto text-uppercase">{{product.surge}}</small>
          </div>
          <ng-container *ngIf="additionalDrawings.length > 0">
            <hr class="mb-0" />
            <div class="d-flex"><b class="fs-5 mb-2">Drawings</b></div>
            <div class="d-flex">
              <button class="btn btn-outline-secondary btn-sm" (click)="getFittingDrawing.emit(dwg)"
                      [ngClass]="{'me-2': first, 'mx-2': !first}"
                      *ngFor="let dwg of additionalDrawings; let first=first">{{dwg}}</button>
            </div>
          </ng-container>
          <hr />
          <div class="d-flex">
            <div class="d-flex flex-column w-100">
              <div class="d-flex flex-wrap">
                <b class="w-25 text-nowrap">Pipe Size:</b><span class="ms-auto">{{product.pipeSize}}</span>
              </div>
              <div class="d-flex flex-wrap">
                <b class="w-25 text-nowrap">Branch Size:</b><span class="ms-auto">{{product.branchSize}}</span>
              </div>
              <div class="d-flex flex-wrap">
                <b class="w-25 text-nowrap">Flange Type:</b><span class="ms-auto">{{product.flangeType}}</span>
              </div>
              <div class="d-flex mx-auto my-3" *ngIf="!!product.image">
                <img style="width: 250px;" [src]="(product.image || '') | imgFromBytes" alt="">
              </div>
            </div>


          </div>

          <ng-container>
            <hr />
            <app-product-configurations *ngIf="configurationsWithoutFilter.length > 0"
                                        [configurationFilter]="configurationFilter" [configurations]="configurations"
                                        [partNumber]="product.partNumber" [defaultDescription]="product.productName"
                                        [configurationsWithoutFilter]="configurationsWithoutFilter"
                                        [configurationFilterIsApplied]="(hasFilterApplied$ | async) || false"
                                        [tappedHoleOptions]="(tappedHoleOptions$ | async) || []"
                                        [oringOptions]="(oringOptions$ | async) || []" [bevelOptions]="(bevelOptions$ | async) || []"
                                        (liftingLugsChanged)="configurationTopLevelFilterChange({liftingLugs: $event})"
                                        (magInspectionChanged)="configurationTopLevelFilterChange({magInspection: $event})"
                                        (buyAmericaChanged)="configurationTopLevelFilterChange({buyAmerica: $event})"
                                        (tappedBlindChanged)="configurationTopLevelFilterChangeTappedBlindOption($event)"
                                        (oringChanged)="configurationTopLevelFilterChangeOringOption($event)"
                                        (bevelChanged)="configurationTopLevelFilterChangeBevelOption($event)">
            </app-product-configurations>
          </ng-container>
          <hr />
          <div class="d-flex">
            <b class="w-25 text-">Class:</b><span class="ms-2">{{product.class}}</span>
          </div>
          <div class="d-flex">
            <b class="w-25 text-">Design Codes:</b><span class="ms-2">{{product.designCodes}}</span>
          </div>
          <hr />
          <div class="d-flex">
            <b class="w-25 text-">Design Temp:</b><span
                  class="ms-2">{{product.minDesignTemp}}&nbsp;to&nbsp;{{product.maxDesignTemp}}</span>
          </div>

          <app-design-pressures [designPressures]="product.designPressures"></app-design-pressures>
          <app-associated-products [products]="product.associatedProducts"
                                   (getFittingAssociatedDrawing)="getFittingAssociatedDrawing.emit($event)">
          </app-associated-products>

          <app-replaces-parts [replacedParts]="product.replacedParts"></app-replaces-parts>
        </div>
      </ng-container>

    </div>
  </div>
</div>
